<div class="design-home-page-div">
    <div>
        <button mat-raised-button
                class="button-primary"
                [disabled]="this.DesignHomePageDisabled"
                (click)="this.designHomePageClicked()">
            {{this.DesignHomePageButtonText}}
        </button>
    </div>

    <div class="activate-deactivate-home-page-div">
        <mat-button-toggle-group name="betaFeaturesStatus" aria-label="Site Home Page Status">
            <!-- <mat-button-toggle [ngClass]="(!this.HomePageIsActive ? 'site-home-page-deactivated' : '')"
                               value="beta-features-disabled"
                               [disabled]="this.HomePageNotYetCreated"
                               [checked]="this.HomePageIsActive"
                               (click)="this.deactivateSiteHomePage()">
                {{this.DeactivateButtonText}}
                <mat-icon>work_off</mat-icon>
            </mat-button-toggle> -->

            <!-- VNEXT-1430: KLW - Removing checkbox -->
            <mat-button-toggle [ngClass]="(!this.HomePageIsActive ? 'site-home-page-deactivated' : '')"
                value="beta-features-disabled" 
                [disabled]="this.HomePageNotYetCreated"
                (click)="this.deactivateSiteHomePage()">
                {{this.DeactivateButtonText}}
                <mat-icon>work_off</mat-icon>
            </mat-button-toggle>

            <!-- <mat-button-toggle [ngClass]="(this.HomePageIsActive ? 'site-home-page-activated' : '')"
                               value="beta-features-enabled"
                               [disabled]="this.HomePageNotYetCreated"
                               [checked]="!this.HomePageIsActive"
                               (click)="this.activateSiteHomePage()">
                {{this.ActivateButtonText}}
                <mat-icon>work</mat-icon>
            </mat-button-toggle> -->

            <!-- VNEXT-1430: KLW - Removing checkbox -->
            <mat-button-toggle [ngClass]="(this.HomePageIsActive ? 'site-home-page-activated' : '')" value="beta-features-enabled"
                [disabled]="this.HomePageNotYetCreated" 
                (click)="this.activateSiteHomePage()">
                {{this.ActivateButtonText}}
                <mat-icon>work</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <div *ngIf="this.ShowEnableStructureForEndUsers"
         class="enable-structure-div">
        <mat-checkbox [(ngModel)]="this.EnableStructureForEndUsers"
                      (ngModelChange)="this.enableStructureForEndUsersToggled()"
                      class="enable-structure-check-box">
            <span>Enable Structure for End Users?</span>
        </mat-checkbox>
    </div>

    <!-- Define a "test XYZ" for site admins. -->
    <!-- Note:  if you remove the false in the following *ngIf expression, please do not check the file in to source control. -->
    <!--
    <div *ngIf="false && this.UserIsSystemAdmin"
         class="test-something-div">
        <button mat-raised-button
                color="primary"
                (click)="this.testSomethingClicked()">
            {{this.TestSomethingButtonText}}
        </button>
    </div>
    -->
</div>
